import { render, staticRenderFns } from "./ListArchive.vue?vue&type=template&id=7ab36214&"
import script from "./ListArchive.vue?vue&type=script&lang=ts&"
export * from "./ListArchive.vue?vue&type=script&lang=ts&"
import style0 from "./ListArchive.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports